module.exports = __webpack_public_path__ + "img/message.800b17e5.png";